import React, { Fragment } from 'react';
import { Link } from 'site-modules/shared/components/link/link';

export const BRAND_PAGE_FILTER = {
  ALL: 'all',
  CAR_REVIEWS: 'car-reviews',
};

export const BRAND_ALIGNMENT_ITEMS = (pageFilter = BRAND_PAGE_FILTER.ALL) =>
  [
    {
      label: 'Know before you buy',
      description: (
        <Fragment>
          Honest{' '}
          <Link
            to="/car-reviews/"
            rel="nofollow"
            className="text-primary-darker text-underline"
            data-tracking-id="view_content"
            aria-label="Expert Car Reviews"
          >
            reviews
          </Link>
          , rankings and video test-drives
        </Fragment>
      ),
      icon: 'icon-star-empty',
      filter: [BRAND_PAGE_FILTER.ALL],
    },
    {
      label: 'Know before you buy',
      description: (
        <Fragment>
          Honest{' '}
          <Link
            to="/car-reviews/car-reviews-road-tests.html"
            rel="nofollow"
            className="text-primary-darker text-underline"
            data-tracking-id="view_content"
            aria-label="Expert Car Reviews"
          >
            reviews
          </Link>
          , rankings and video test-drives
        </Fragment>
      ),
      icon: 'icon-star-empty',
      filter: [BRAND_PAGE_FILTER.CAR_REVIEWS],
    },
    {
      label: 'Know your offer',
      description: (
        <Fragment>
          Deal ratings on{' '}
          <Link
            to="/new-cars/"
            rel="nofollow"
            className="text-primary-darker text-underline"
            data-tracking-id="view_content"
            aria-label="New Car Pricing"
          >
            new
          </Link>{' '}
          and{' '}
          <Link
            to="/used-cars-for-sale/"
            rel="nofollow"
            className="text-primary-darker text-underline"
            data-tracking-id="view_content"
            aria-label="Used Car Listing"
          >
            used
          </Link>{' '}
          listings near you
        </Fragment>
      ),
      icon: 'icon-good-deal',
    },
    {
      label: 'Know your financing',
      description: (
        <Fragment>
          Prequalify for financing and{' '}
          <Link
            to="/financing/prequalify-and-shop/intro/"
            rel="nofollow"
            className="text-primary-darker text-underline"
            data-tracking-id="open_financing_app"
            data-tracking-value="financing"
            aria-label="Know your real payment with Capital One"
          >
            know your real payment
          </Link>
        </Fragment>
      ),
      icon: 'icon-calculator',
    },
    {
      label: 'Know your trade-in value',
      description: (
        <Fragment>
          Instant{' '}
          <Link
            to="/appraisal/"
            rel="nofollow"
            className="text-primary-darker text-underline"
            data-tracking-id="view_content"
            aria-label="Online Appraisal Tool"
          >
            online appraisal
          </Link>{' '}
          — fast and free
        </Fragment>
      ),
      icon: 'icon-appraisal',
    },
  ].filter(({ filter }) => !filter || filter.includes(pageFilter));
